<template>
    <div class="errorPage">
        <img src="../../static/img/404.png" class="error" alt="">
        <div class="toolBox">
            <span class="home" @click="home">返回首页</span>
            <span class="back" @click="back">返回上一页</span>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        home() {
            let data = JSON.parse(window.sessionStorage.getItem('tree'))[0].path
            this.$router.push({
                path: data
            })
        },
        back() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
    .errorPage{
        width: 100%;
        height: 100%;
        text-align: center;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        .error{
            margin-top: 100px;
            width: 600px;
        }
        .toolBox{
            margin-top: 30px;
        }
        .home{
            font-size: 18px;
            cursor: pointer;
        }
        .back{
            font-size: 18px;
            margin-left: 30px;
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/errorPage.vue